'use client';

import Toggle from 'components/Faq/Toggle';
import TabItem from 'components/shared/Tabs/TabItem';
import { ToggleItemProps, ToggleMenuProps } from 'libs/contentful/props';
import { useState } from 'react';
import { liveUpdateAttrs } from 'libs/contentful/utils';
import { StyleVariant } from './constants';

const ToggleMenu = ({ variant = StyleVariant.Default, toggleItems, sys, color }: ToggleMenuProps) => {
  const [activeToggleItem, setActiveToggleItem] = useState<ToggleItemProps>(toggleItems[0]);

  const handleClick = (item: ToggleItemProps) => {
    setActiveToggleItem(item);
  };

  return (
    <div className="mt-6 md:mt-14">
      {toggleItems.length > 1 && (
        <div {...liveUpdateAttrs(sys?.id, 'content')}>
          <div className="md:flex md:flex-row md:w-max bg-mint rounded-md">
            {toggleItems.map((item, i) => (
              <TabItem
                isActive={item.tabCopy === activeToggleItem.tabCopy}
                id={item.tabCopy}
                key={`tab-item-${item.tabCopy}-${i}`}
                onClick={() => handleClick(item)}>
                {item.tabCopy}
              </TabItem>
            ))}
          </div>
        </div>
      )}
      <Toggle
        sys={activeToggleItem.sys}
        tabCopy={activeToggleItem.tabCopy}
        accordionItems={activeToggleItem.contentCollection}
        color={color}
        key={`toggle-item-${activeToggleItem.tabCopy}`}
        variant={variant}
      />
    </div>
  );
};

export default ToggleMenu;
